import axios from 'axios'
import { getToken, clearLoginStatus } from './auth'

const isElectronClient = () => {
  if (typeof window !== 'undefined' && window.ibotDesktop?.isElectron) return true
  if (typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent)) return true
  return false
}

const request = axios.create({
  baseURL: (process.env.NODE_ENV === 'development' || isElectronClient()) ? '/api' : 'https://www.ibot.top/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

request.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      clearLoginStatus()
    }
    return Promise.reject(error)
  }
)

export default request
